// Hardcoded fallback category list for the FormIQ3 Tree Protection showcase
// (Baumschutz - Ausnahmegenehmigung beantragen). Mirrors the `document_types`
// / `predicted_document_type` taxonomy of the form3_baumschutz
// DOCUMENT_CATEGORISE pipeline config.
export const DOCUMENT_CATEGORIES = [
  {
    id: 'vollmacht',
    label: 'Vollmacht',
    description: 'Vollmacht zur Antragstellung',
    keywords: ['vollmacht', 'power of attorney', 'authorization'],
  },
  {
    id: 'lageplan',
    label: 'Lageplan',
    description: 'Lageplan oder Lageskizze des Baumbestands',
    keywords: ['lageplan', 'lage', 'plan', 'skizze', 'karte', 'site', 'location'],
  },
  {
    id: 'vorhabensbeschreibung',
    label: 'Vorhabensbeschreibung',
    description: 'Beschreibung der geplanten Maßnahme am Baumbestand',
    keywords: ['vorhabensbeschreibung', 'vorhaben', 'massnahme', 'maßnahme', 'begruendung', 'project description'],
  },
  {
    id: 'nachweis_gebuehrenbefreiung',
    label: 'Nachweis Gebührenbefreiung',
    description: 'Nachweis zur Befreiung von Gebühren',
    keywords: ['gebuehrenbefreiung', 'gebührenbefreiung', 'gebuehren', 'fee exemption'],
  },
  {
    id: 'misc',
    label: 'Sonstige',
    description: 'Dokumente, die keiner der übrigen Kategorien zugeordnet werden konnten',
    keywords: [],
  },
];

// True if the given category value matches a predefined category's id or
// label (case-insensitive) - used to compute the `needs_review` flag for
// free-text corrections (FIQ3-B02).
export function isPredefinedCategory(value, categories = DOCUMENT_CATEGORIES) {
  const normalized = (value || '').trim().toLowerCase();
  if (!normalized) return false;
  return categories.some(
    (c) => c.id.toLowerCase() === normalized || c.label.toLowerCase() === normalized
  );
}
